var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        speed: _vm.speed,
        width: _vm.columns * _vm.coverWidthWithPadding,
        height: _vm.rows * _vm.coverHeightWithPadding,
        "primary-color": "#242b34",
        "secondary-color": "#343d4c",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "0",
          y: "0",
          rx: "0",
          ry: "0",
          width: _vm.rectWidth,
          height: "5",
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.covers, function (g, idx) {
        return _c("rect", {
          key: "rect-" + idx,
          attrs: {
            x: _vm.getVx(idx, _vm.columns),
            y: _vm.getVy(idx, _vm.columns),
            rx: "0",
            ry: "0",
            width: _vm.coverWidth,
            height: _vm.coverHeight,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }